<template>
  <v-container class="section mt-16 pt-8" id="products">
    <!-- The section heading -->
    <div
      class="font-weight-bold bluegray--text text-h4 text-center"
      v-vue-aos.once="{ animationClass:'fadeIn slow animated' }"
    >
      The <span class="primary--text">Smartest</span> and Most <span class="primary--text">Accurate</span> Influencer Marketing Platform
    </div>

    <!-- The subtitle -->
    <div
      class="section__subtitle text-center mt-4"
      v-vue-aos.once="{ animationClass:'fadeIn slow animated' }"
    >
      The 3 Core aspects to Getting your Influencer Marketing Right&nbsp;-&nbsp;By as Much as 70%
    </div>

    <!-- The container for feature cards -->
    <v-row class="mt-16 pt-8 d-flex justify-center">
      <v-col
        cols="12"
        lg="11"
      >
        <!-- Influencer Discovery -->
        <v-row
          class="align-center"
          v-vue-aos.once="{ animationClass:'fadeIn slow animated delay-1s' }"
        >
          <!-- Left -->
          <v-col cols="12" md="7">
            <v-img
              contain
              max-width="600"
              v-prlx="{ reverse: true }"
              src="/img/products/influencer-discovery.png"
            />
          </v-col>

          <!-- Right -->
          <v-col cols="12" md="5">
            <!-- The title -->
            <div class="font-weight-bold text-h5 primary--text">
              Influencer Discovery
            </div>

            <!-- The subtitle -->
            <div class="mt-2 font-weight-bold bluegray--text text-h4">
              What If You Could FInd Influencers with Business Merit
            </div>

            <!-- The text -->
            <div class="mt-4">
              Using a Multitude of Filters for them & Their  Audiences -  Age, Sex, Location, Authenticity, Engagement, Relevance and aspects that can do truly incisive and Business Impacting
            </div>
          </v-col>
        </v-row>

        <!-- Influencer Insights -->
        <v-row
          class="align-center mt-16"
          v-vue-aos.once="{ animationClass:'fadeIn slow animated' }"
        >
          <!-- Left -->
          <v-col cols="12" md="6">
            <!-- The title -->
            <div class="font-weight-bold text-h5 primary--text">
              Influencer Insights
            </div>

            <!-- The subtitle -->
            <div class="mt-2 font-weight-bold bluegray--text text-h4">
              Get demographic analysis for the profile
            </div>

            <!-- The text -->
            <div class="mt-4">
              Know every detail about Influencers' Audience - Fake Vs Real followers, Relevance and Impact
            </div>
          </v-col>

          <!-- Right -->
          <v-col cols="12" md="6">
            <v-img
              contain
              max-width="400"
              v-prlx="{ reverse: true }"
              src="/img/svg/influencer-insights.svg"
            />
          </v-col>
        </v-row>

        <!-- Paid Collaborations -->
        <v-row
          class="align-center mt-16"
          v-vue-aos.once="{ animationClass:'fadeIn slow animated' }"
        >
          <!-- Left -->
          <v-col cols="12" md="6">
            <v-img
              contain
              max-width="400"
              v-prlx="{ reverse: true }"
              src="/img/svg/paid-collaborations.svg"
            />
          </v-col>

          <!-- Right -->
          <v-col cols="12" md="6">
            <!-- The title -->
            <div class="font-weight-bold text-h5 primary--text">
              Paid Collaborations
            </div>

            <!-- The subtitle -->
            <div class="mt-2 font-weight-bold bluegray--text text-h4">
              Compare with your competitors
            </div>

            <!-- The text -->
            <div class="mt-4">
              Track & Audit your  Brand and that of your Competitors - See Real time what Influencers are doing for Any brand anywhere
            </div>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
// Export the SFC
export default {
  // Name of the component
  name: "Features",
}
</script>

<style lang="stylus" scoped>
.section
  &__subtitle
    font-size 1.125em
</style>